export enum TIME_ZONES {
  PUERTO_RICO = 'Puerto Rico',
  NEW_YORK = 'New York',
  CHICAGO = 'Chicago',
  DENVER = 'Denver',
  PHOENIX = 'Phoenix',
  LOS_ANGELES = 'Los Angeles',
  ANCHORAGE = 'Anchorage',
  HAWAII = 'Hawaii',
}
